import { FC } from 'react';
import { ReactComponent as USFlag } from '../../icons/flags/us.svg';
import { ReactComponent as EUFlag } from '../../icons/flags/eu.svg';

const Flag: FC<{ flag: string }> = ({ flag }) => {
    switch (flag) {
        case 'us':
            return <USFlag className="w-6 h-6" />;
        case 'eu':
            return <EUFlag className="w-6 h-6" />;
        case 'uk':
            return <EUFlag className="w-6 h-6" />;
        case 'worldwide':
            return '🌍';
        case 'ca':
            return '🇨🇦';
        case 'au':
            return '🇦🇺';
        case 'rest of the world':
            return '🌍';
        default:
            return '';
    }
};

export default Flag;
